module.exports = "/React/dist/9968533fb2088f073d15842f5f90977c.png";